// Post-Phase-6 slim.
//
// The 27 FUNCTION_* Function-class instances that previously lived here (one
// per SAP function like WARENEINGANG, AUSLAGERUNG, …) plus their 9 companion
// `_LINK` HTML strings were removed after the Scenario page migrated to
// fetching `GET /functions?lang=…` (Phase 6). What remains:
//
//  - 5 category string constants — imported by FunctionUtils / Scenario /
//    FunctionCardCollection UI code as `typeOf` labels.
//  - SONDERFUNKTION — the special-functions category label (client-only,
//    per-client user-generated content, not a seeded DB function).
//  - FUNCTION_SONDERFUNKTIONEN_ERWEITERUNGEN — a plain-object stand-in for
//    the "Sonderfunktionen & Erweiterungen" tile. Previously a
//    `new Function(...)` instance; now a plain object matching the shape
//    the API returns for other functions ({systemID, name, type, typeOf,
//    data}). This lets us delete `src/Models/Function.js` since nothing
//    else uses that class.

export const WAREHOUSE_LOGISTICS = `WAREHOUSE_LOGISTICS`;
export const PRODUCTION_AND_WAREHOUSE_ENHANCE_PACKAGE = `PRODUCTION_AND_WAREHOUSE_ENHANCE_PACKAGE`;
export const MOBILE_INVENTORY_SOLUTIONS = `MOBILE_INVENTORY_SOLUTIONS`;
export const DUMMY_SOLUTIONS = `DUMMY_SOLUTIONS`;
export const PLANT_MAINTENANCE = `PLANT_MAINTENANCE`;
export const SONDERFUNKTION = `SONDERFUNKTION`;

export const FUNCTION_SONDERFUNKTIONEN_ERWEITERUNGEN = {
  systemID: "F_SONDERFUNKTIONEN_ERWEITERUNGEN",
  name: "Sonderfunktionen & Erweiterungen",
  type: [],
  typeOf: SONDERFUNKTION,
  data: [],
};
